<div class="section" id="projects">
    <div class="container py-2 cc-projects">
        <div class="h4 text-center mb-4 title">Projects</div>
        <div class="row">
            <ul class="timeline">
               
              <li>
                    <div class="timeline-badge up bg-green">
                        <i class="fa fa-thumbs-up"></i>
                    </div>
                    <div class="timeline-panel">
                        <div class="row">
                            <div class="col-lg-6 ">
                                <div class="h5 mt-0 title">Cricket Fever</div>
                                <div class="h6 mt-0 title">Live Streaming Web Application</div>
                            <p align="justify"><b>Cricket Fever</b> 
                                     is a full-stack live cricket streaming web application I developed to combine my passion for sports with my technical skillset. 
                                          The platform features a responsive, subscription-based model that enables users to stream matches in
                                          real time with smooth performance across devices. I built the front end using React (with Vite), TypeScript, Tailwind CSS, and Redux, 
                                          focusing on clean UI and mobile-first responsiveness. On the backend, I used Node.js and Supabase with PostgreSQL to manage user authentication, role-based access control, and secure data storage. The application is deployed on Vercel with an automated CI/CD pipeline for seamless updates and fast load times. Real-time data interactions were a core feature, and I ensured that content delivery remained consistent under load. Currently, I’m exploring ways to integrate Generative AI features like automated match summaries and personalized highlights to enhance user engagement. This project reflects my ability to build end-to-end scalable solutions and experiment with modern technologies in a real-world context.
                                        
                            </div>
                            <div class="col-lg-6">
                                <ul>
                                    <li class="list">Application Source Links</li>
                                    <ul>
                                        <li class="non_list">Github link :
                                            <a href="https://github.com/Vam564/Cricket_Fever-">Cricket_Fever</a></li>
                                        <li class="non_list">Website URL :
                                            <a href="https://cricketfever.online">CricketFever.online</a></li>
                                    </ul>
                                   <li class="list">Technologies and Language</li>
                                            <ul>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <li class="non_list">React Vite</li>
                                                        <li class="non_list">TypeScript</li>
                                                        <li class="non_list">Redux Thunk</li>
                                                        <li class="non_list">Rest API</li>
                                                        <li class="non_list">Git</li>
                                                    </div>
                                                    <div class="col-md-6">
                                                      <li class="non_list">Node.Js</li>
                                                        <li class="non_list">PostGres</li>
                                                        <li class="non_list">Supabase</li>
                                                        <li class="non_list">ES6</li>
                                                        <li class="non_list">Tailwind CSS</li>
                                                    </div>
                                                </div>   
                                            </ul>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="timeline-badge up bg-green">
                        <i class="fa fa-thumbs-up"></i>
                    </div>
                    <div class="timeline-panel">
                        <div class="row">
                            <div class="col-lg-6 ">
                                <div class="h5 mt-0 title">Quick Trailer Project</div>
                                <div class="h6 mt-0 title">React Based Web Application</div>
                                <p align="justify"><b>Quick Trailer Web Application:</b> Developed a fully responsive web app using React JS and Web API, designed to provide users with a seamless experience for watching movie trailers. The app allows users to filter movies by categories such as upcoming, latest releases, popular, and now playing. Additionally, it 
                                    features a voice search function, enabling users to find movies easily by speaking the title.</p>
                            </div>
                            <div class="col-lg-6">
                                <ul>
                                    <li class="list">Application Source Links</li>
                                    <ul>
                                        <li class="non_list">Github link :
                                            <a href="https://github.com/Vam564/Quick_Trailer-">Quick_Trailer</a></li>
                                        <li class="non_list">Website URL :
                                            <a href="https://quicktrailer.netlify.app">https://quicktrailer.netlify.app</a></li>
                                    </ul>
                                    <li class="list">Technologies Used</li>
                                    <ul>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <li class="non_list">React</li>
                                                <li class="non_list">JavaScript</li>
                                                <li class="non_list">Rest API</li>
                                                <li class="non_list">Git</li>
                                            </div>
                                            <div class="col-md-6">
                                                <li class="non_list">Redux</li>
                                                <li class="non_list">Material UI</li>
                                                <li class="non_list">ES6</li>
                                                <li class="non_list">CSS3</li>
                                            </div>
                                        </div>
                                    </ul>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="timeline-badge up bg-green">
                        <i class="fa fa-thumbs-up"></i>
                    </div>
                    <div class="timeline-panel">
                        <div class="row">
                            <div class="col-lg-6 ">
                                <div class="h5 mt-0 title">Stock Brokerage Project </div>
                                <div class="h6 mt-0 title">React Based Web Application</div>
                                <p align="justify"><b>Stock Brokerage Application:</b>Developed a dynamic web application using React JS, Firebase, and API integration, enabling users to buy, sell, and manage stocks efficiently. The app allows users to register, sign in, 
                                    and save their favorite stocks for quick access, providing a seamless stock trading experience.</p>
                            </div>
                            <div class="col-lg-6">
                                <ul>
                                    <li class="list">Application Source Links</li>
                                    <ul>
                                        <li class="non_list">Github link :
                                            <a href="https://github.com/Vam564/StocksManagement">StocksManagement</a></li>
                                        <!-- <li class="non_list">Website URL :
                                            <a href="https://quicktrailer.netlify.app">https://quicktrailer.netlify.app</a></li> -->
                                    </ul>
                                    <li class="list">Technologies Used</li>
                                    <ul>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <li class="non_list">React</li>
                                                <li class="non_list">JavaScript</li>
                                                <li class="non_list">Rest API</li>
                                                <li class="non_list">Git</li>
                                                <li class="non_list">Firebase</li>
                                            </div>
                                            <div class="col-md-6">
                                                <li class="non_list">Redux</li>
                                                <li class="non_list">Material UI</li>
                                                <li class="non_list">ES6</li>
                                                <li class="non_list">CSS3</li>
                                            </div>
                                        </div>
                                    </ul>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
